import { Vue, Component, Watch } from 'vue-property-decorator'
import ProductList from '@/components/dashboard/product/product-list/ProductList.component.vue'
import ProductFilter from '@/components/dashboard/product/product-filter/ProductFilter.component.vue'
import { CustomerSummary, TableHeader } from '@/types'
import Axios from 'axios'

@Component({
  components: {
    ProductList,
    ProductFilter
  }
})
export default class CustomerPageComponent extends Vue {
  items: CustomerSummary[] = []
  toggleFilter: boolean = false
  totalPage: number = 1
  page: number = 1
  dataFilter: Object = {
    from: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
    to: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().substr(0, 10)
  }

  loadingData: boolean = false

  itemsTotals = []
  headerTotals: TableHeader[] = [
    {
      text: 'Total General',
      value: 'title',
      sortable: false
    },
    {
      text: 'Grabado',
      value: 'taxedAmount',
      sortable: false
    },
    {
      text: 'Exonerado',
      value: 'exoneratedAmount',
      sortable: false
    },
    {
      text: 'I.G.V.',
      value: 'taxAmount',
      sortable: false
    },
    {
      text: 'Total',
      value: 'totalAmount',
      sortable: false
    }
  ]

  @Watch('page')
  changePage (value:number, oldValue:number) {
    this.loadCustomerSummary()
  }

  mounted () {
    this.loadCustomerSummary()
  }

  loadCustomerSummary () {
    this.loadingData = true
    Axios.get('/documents/summary-products', {
      params: {
        ...this.dataFilter,
        page: this.page
      }
    }).then(response => {
      this.items = response.data.page.data
      this.totalPage = response.data.page.last_page
      this.loadingData = false
    })
  }

  onFilter (data:Object) {
    this.dataFilter = data
    this.loadCustomerSummary()
  }
}
